import { userServices } from '../services/usersServices';

import { UserActions, } from '../types/UserActions';
import { UserBody } from '../types/UsersBody';

const usersList = () => (dispatch: any) => {
	const success = (data: UserBody[]): UserActions =>
		({ type: 'USERS_LIST', data });

	userServices.list().then((res: any) => { dispatch(success(res)) });
}

export {
	usersList,
}